import { DialpadService } from './../../../services/dialpad.service';
import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { TelephonyStateService } from '../../../providers/telephony/telephony.state.service';
import { NavService } from '../../../services/nav.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ThemesService } from '../../../features/setting/services/themes.service';
import { CampaignService } from '../../../services/campaign.service';

@Component({
  selector: 'app-right-side-bar',
  templateUrl: './right-side-bar-updated.component.html',
  styleUrls: ['./right-side-bar.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ width: 0, transform: 'translateX(283px)' }),
        animate('800ms', style({ width: '21%', transform: 'translateX(0)' })),
      ]),
      transition(':leave', [animate('800ms', style({ width: 0, transform: 'translateX(283px)' }))]),
    ]),
  ],
})
export class RightSideBarComponent implements OnInit {
  @Input() isDraggable: boolean;
  @Input() isCompact: boolean;

  constructor(
    public campaignService: CampaignService,
    public navService: NavService,
    private authService: AuthenticationService,
    public telephonyStateService: TelephonyStateService,
    public dialpadService: DialpadService,
    public themeService: ThemesService
  ) {
    this.isDraggable = dialpadService.isDraggable;
    this.isCompact = dialpadService.isCompact;
  }

  ngOnInit(): void {}
  
  onCloseDialpad() {
    this.navService.setSideNav(false, 'right');
  }
}
